<template>
  <ContextMenu
    :visible="visible"
    :positionX="position.x"
    :positionY="position.y"
    @closeContextMenu="$emit('close')"
    >
    <div>
      <b-list-group>
        <b-list-group-item
          href="#"
          @click.prevent="renameTab"
          >
          Rename
        </b-list-group-item>
        <b-list-group-item
          href="#"
          @click.prevent="setDefaultSubTab"
          class="contextMenu__toggle"
        >
          Selected by default
          <b-badge
            v-if="tabs[currentTab] && tabs[currentTab].defaultSubTab === currentSubTab"
            variant="primary"
            pill>
            <icon name="check" />
          </b-badge>
        </b-list-group-item>
        <b-list-group-item
          v-if="$count(subTabs[this.currentTab]) > 1"
          href="#"
          @click.prevent="deleteSubTab"
          >
          Delete
        </b-list-group-item>
      </b-list-group>
    </div>
    <TabRenameModal
      ref="tabRenameModal"
      :tabs="tabs"
      :subTabs="subTabs"
    />
  </ContextMenu>
</template>

<script>
import { mapState } from 'vuex'
// components
import ContextMenu from '@/components/ContextMenu'
import TabRenameModal from '../modals/TabRename'
// servics
import db from '@/services/db'

export default {
  props: [
    'visible', 'position',
    'tabs', 'subTabs'
  ],
  components: {
    ContextMenu,
    TabRenameModal
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab'
    ])
  },
  methods: {
    async deleteSubTab () {
      let confirmDel = confirm('Are you sure?')

      if (!confirmDel) return
      this.$emit('close')

      await db.tabs.deleteSubTab(this.currentTab, this.currentSubTab)

      this.$emit('delete')
    },
    setDefaultSubTab () {
      if (this.tabs[this.currentTab].defaultSubTab === this.currentSubTab) {
        db.tabs.toggleDefaultSubTab(this.currentTab, null)
      } else {
        db.tabs.toggleDefaultSubTab(this.currentTab, this.currentSubTab)
      }
    },
    renameTab () {
      this.$refs.tabRenameModal.open(true)
    }
  }
}
</script>
